import styled from "styled-components/macro";
import { PrimaryButton, ButtonText, InputSwitch } from "@loanbossinc/component-library";

export const TypeSelectionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 17px 0 17px;
  box-shadow: 0px 10px 20px rgba(173, 174, 174, 0.25);
  border: 1px solid #dadce0;
`;

export const InputDropdownWrapper = styled.div`
  padding: 0.7em 0 0.7em 0;
  width: ${props => (props.fullWidth ? "100%" : "45%")};
`;

export const InputTextWrapper = styled.div`
  width: ${props => (props.fullWidth ? "100%" : "45%")};
  padding-top: 0.7em;
`;

export const InputGroupLabel = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  text-transform: uppercase;
  color: #5f6368;
`;

export const InputGroupWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: ${(props) => (props.horizontalDivider && "1px solid #dadce0")};
  padding: 17px;
  box-sizing: border-box;
`;

export const ComparisonHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 10px 20px rgba(173, 174, 174, 0.25);
  border-top: 1px solid #dadce0;
  border-bottom: 1px solid #dadce0;
  padding: 0 17px 0 17px;
`;

export const ResultPreviewContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PreviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${props => (props.left ? "17px 0 0 85px" : "17px 85px 0 0")};
  box-sizing: border-box;
`;

export const PreviewButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 4px;
  margin-bottom: -8px;
  height: 36px;
`;

export const ResultPreviewLabel = styled.div`
  width: 160px;
  height: 45px;
  background: #fafafa;
  border: 1px solid #dadce0;
  box-sizing: border-box;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TypeSelectionContainerComparison = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledOr = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Work Sans;
  width: 100px;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #5f6368;
`;

export const InputGroupsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const InputGroupSection = styled.div`
  width: calc(50% - 0.5px);
  display: flex;
  flex-direction: column;
`;

export const VerticalSeparator = styled.div`
  border-left: 1px solid #dadce0;
  height: auto;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 17px 17px 17px;
`;

export const ResultPreviewContainerHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  height: 100%;
`;

export const ResultPreview = styled.div`
  width: 160px;
  height: 45px;
  background-color: #fafafa;
  border-radius: 8px;
  border: 1px solid #dadce0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.7em;
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
`;

export const ResultPreviewLabelHeader = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  color: #5f6368;
  padding-right: 2.2em;
`;

export const StyledDoneButton = styled(PrimaryButton)`
  && {
    background-color: #005aa9 !important;
    width: 132px !important;
    height: 36px !important;
    display: flex;
    justify-content: center;
    &:disabled,
    &[disabled] {
      background-color: #c4c4c4 !important;
    }
  }
`;

export const StyledButtonText = styled(ButtonText)`
  & .MuiButton-label .material-icons {
    margin-right: 10px !important;
  }
`;

export const PreviewButtonResult = styled.div`
  display: flex;
  align-items: baseline;
`;

export const PreviewButtonContainer = styled.div`
  width: 100px;
`;

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  & .MuiFormControlLabel-labelPlacementStart {
    margin-left: 0 !important;
  }
`;

export const StyledLockedSwitch = styled(InputSwitch)`
  & .Mui-checked {
    color: #2c98f0 !important;
  }
`;

export const SwitchLabelWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;
  padding: 17px 17px 0 1em;
  width: ${props => (props.width ? props.width : "auto")};
`;
